



































import Vue from 'vue';
import notranslate from '../notranslate';

export interface Option {
  key: string;
  value: string;
  img?: string;
}

export default Vue.extend({
  directives: { notranslate },
  props: {
    value: {
      type: Object as Vue.PropType<Option>,
      required: true,
    },
    options: {
      type: Array as Vue.PropType<Option[]>,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    focused: {
      type: Boolean,
      default: false,
    },
    selectedMark: {
      type: Boolean,
      default: false,
    },
    highlightedText: {
      type: String,
      default: '',
    },
  },
  data() {
    const selected: Option = this.value;
    return {
      selected,
    };
  },
  watch: {
    value(newValue: Option): void {
      this.selected = newValue;
    },
  },
  methods: {
    selectOption(option: Option) {
      this.selected = option;
      this.$emit('selected', this.selected);
    },
    isOptionSelected(option: Option): Boolean {
      return this.selected.value === option.value;
    },
    /**
     * Quebra o texto da opção em antes/trecho casado/depois, para o template destacar
     * o match com <b> sem v-html.
     *
     * A versão anterior montava HTML com `new RegExp(this.highlightedText)` e injetava
     * com v-html. Dois problemas: o texto digitado ia cru para dentro de uma regex,
     * então caractere especial ('(', '[', '*') lançava SyntaxError e matava o dropdown
     * inteiro; e o valor da opção ia cru para dentro do DOM como HTML. Comparar por
     * índice resolve os dois sem depender de escape.
     */
    highlightParts(option: Option): { before: string; match: string; after: string } {
      const term = this.highlightedText;

      if (!term) return { before: option.value, match: '', after: '' };

      const start = option.value.toLowerCase().indexOf(term.toLowerCase());

      if (start === -1) return { before: option.value, match: '', after: '' };

      return {
        before: option.value.slice(0, start),
        match: option.value.slice(start, start + term.length),
        after: option.value.slice(start + term.length),
      };
    },
  },
});
